import { useEffect, useRef, useState } from 'react'
import { getQrcode, getStatus } from '../../api'
import { Loading3QuartersOutlined } from '@ant-design/icons'
import moment from 'moment'
import { Popover, Statistic } from 'antd'
import styles from './index.less'
import { Spin } from 'antd'
import { addCookie, addFixedTimeCookie, deleteCookie, getCookie } from '@/utils/cookie'
import { useStore } from '@/states/store'
import CustomerService from '../CustomerService'
import { history } from 'umi';
import { TabType } from '@/pages/personalCenter/config';
import PriceFlipper from '../Price'
import classNames from 'classnames'

const { Countdown } = Statistic
type MyObjectWithIndexSignature = {
  [index: number]: string
}
const type: MyObjectWithIndexSignature = {
  1: 'member',
  2: 'bag',
}
export default ({
  currentTab = 1,
  goodsList = [],
  memberStatus = undefined,
  setTab = (tab: any) => {},
  updateUserInfo = (user: any) => {},
  payStatus = { member: 0, bag: 0 },
  setPayStatus = (value: any) => {},
  pageInfo = '',
  showPromptTab = -1,
  onCancel,
  updateCouponList = (couponList: any) => {},
}: any) => {
  const [currentId, setCurrentId] = useState(-1)
  const [payWay, setPayWay] = useState(1) //1微信 2支付宝
  const [qrCode, setQrCode] = useState('')
  const timer = useRef<any>()
  const [isCanPurchase, setIsCanPurchase] = useState(0) //是否能展示二维码 1否 0是
  const { userInfo } = useStore()
  const [cutdownShow, setCutdownShow] = useState(false)
  const scrollRef=useRef<any>(null)
  const [price, setPrice] = useState(198);

  const deadLineTime = getCookie('activityDeadLineTime_' + userInfo.userId) || null
  // console.log('deadLineTimedeadLineTime',deadLineTime,getCookie('activityDeadLineTime_'+userInfo.userId))
  const [payResult, setPayResult] = useState<any>({
    member: {
      goodName: '',
    },
    bag: {
      goodName: '',
    },
  })
  const [memberExpireTime, setMemberExpireTime] = useState('')
  const [qrCodeLoading, setQrCodeLoading] = useState(false)

  const wximg = 'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/icon_weixinzhifu.png'
  const zfbimg = 'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/icon_zhifubaozhifu.png'
  const currentObj: any = goodsList.filter((i: any) => i.goodsId === currentId)?.[0] || {}
  const benefitType = userInfo?.benefitType; // 支付前存储 当前激活权益类型，判断是否是叠加体验卡
  const isOemSaas=userInfo?.oemFlag===1 && !userInfo?.loginSource
  
  const functionListMap : any = {
    1: {
        title: '立即开通，解锁会员专属功能 / 海量模版 / 极速创作',
        list: [
            {
                icon: 'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/zhutuicon@3x.png',
                text: 'AI商拍图',
            },
            {
                icon: 'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/haibaoicon@3x.png',
                text: 'AI商品海报',
            },
            {
                icon: 'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/shangxiangicon@3x.png',
                text: 'AI商详页',
            },
            {
                icon: 'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/chuangyiicon@3x.png',
                text: 'AI创意海报',
            },
            {
                icon: 'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/zhutuicon@3x.png',
                text: 'AI营销写作',
            },
            {
                icon: 'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/gongjuicon@3x.png',
                text: 'AI作图工具',
            },
        ]
    },
    2: {
        title: '立即购买，解锁无限可能',
        list: [
            {
                icon: 'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/zhutuicon@3x.png',
                text: 'AI 商拍图',
                desc: '10微力/张',
            },
            {
                icon: 'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/haibaoicon@3x.png',
                text: 'AI 商品海报',
                desc: '10微力/张',
            },
            {
                icon: 'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/shangxiangicon@3x.png',
                text: 'AI 商详页',
                desc: '40微力/张',
            },
            {
                icon: 'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/zhutuicon@3x.png',
                text: 'AI 营销写作',
                desc: '2～10微力/篇',
            },
        ],
    }
  }
  
  const promptTxtMap : any = {
    1: '开通会员后，才能继续创作',
    2: '您的剩余微力不足，购买加油包后才能创作',
  };
  
  const goodsIdCardMap: any = {
    24: 3,
    30: 7,
    36: 3,
    37: 7,
    38: 1
  };

  useEffect(() => {
    if (userInfo.userId) {
      try {
        const cookieDeadLine = getCookie('activityDeadLineTime_' + userInfo.userId)
        let deadLineTime = new Date()
        deadLineTime.setHours(deadLineTime.getHours() + 1)
        if (!cookieDeadLine) {
          // deadLineTime.setMinutes(deadLineTime.getMinutes() + 1);

          // console.log('没有cookieDeadLine',deadLineTime.getTime(),deadLineTime.toString())
          addCookie('activityDeadLineTime_' + userInfo.userId, String(deadLineTime.getTime()), 25)
          setCutdownShow(true)
        } else {
          const storageTime = new Date(Number(cookieDeadLine))
          storageTime.setHours(storageTime.getHours() - 1)
          const startOfToday = new Date().setHours(0, 0, 0, 0)
          // console.log('有cookie',deadLineTime,new Date(startOfToday),storageTime,)
          if (startOfToday > storageTime.getTime()) {
            deleteCookie('activityDeadLineTime_' + userInfo.userId)
            addCookie('activityDeadLineTime_' + userInfo.userId, String(deadLineTime.getTime()), 25)
            setCutdownShow(true)
          } else {
            if (Number(cookieDeadLine) > new Date().getTime()) {
              setCutdownShow(true)
            }
          }
        }
      } catch (e) {}
    }
  }, [])

  useEffect(() => {
    try {
      const cookieDeadLine = getCookie('activityDeadLineTime_' + userInfo.userId)
      if (Number(cookieDeadLine) > new Date().getTime()) {
        setCutdownShow(true)
      } else {
        setCutdownShow(false)
      }
      if(scrollRef.current){
        scrollRef.current.scrollTop = 0

      }
    } catch {}
  }, [currentTab])

  useEffect(() => {
    let hasDefault = -1

    if (goodsList?.length > 0) {
      goodsList.some((item: any) => {
        if (item.isDefault === 1) {
          hasDefault = item.goodsId
          return true
        }
      })
      if (pageInfo === 'banner' && currentTab === 1) {
        setCurrentId(3)
      } else if (hasDefault === -1) {
        setCurrentId(currentTab === 1 ? 2 : 5)
      } else {
        setCurrentId(hasDefault)
      }
    }

    return () => {
      clearInterval(timer.current)
    }
  }, [goodsList])

  useEffect(() => {
    if ((currentId !== -1 && memberStatus !== undefined)||currentObj?.couponId) {
      
      if (payStatus[type[currentTab]] === 1 || payStatus[type[currentTab]] === 2) {
        clearInterval(timer.current)
        return
      }
      if(currentObj.goodsType!==currentTab){
        return
      }
      // console.log('currentId',currentId)
      if (currentTab === 2 && memberStatus != 1) {
        //清空计时器
        clearInterval(timer.current)
        return
      }
      

      getCode()
    }
  }, [currentId, payWay, memberStatus,currentObj?.couponId])
  const CreateTimer = (paySerial: any) => {
    timer.current = setInterval(() => continuousMonitoring(paySerial), 2000)
  }

  const continuousMonitoring = (paySerial: any) => {
    getStatus({ paySerial })
      .then((res: any) => {
        if (res.data) {
          const { payStatus: status, memberExpireTime: time } = res.data || {}

          if (currentTab === 1) {
            setPayStatus({ ...payStatus, member: status })
            if (status === 1) {
              setMemberExpireTime(moment(time).format('YYYY.MM.DD'))
            }
          } else {
            setPayStatus({ ...payStatus, bag: status })
          }
          if (status === 1) {
            updateUserInfo((user: any) => {
              // setUserInfo(user)
            })
            updateCouponList()
          }
          if (status !== 0) {
            clearInterval(timer.current)
          }
        }
      })
      .catch((err: any) => {
        clearInterval(timer.current)
      })
  }
  const getCode = () => {
    // console.log('getCode',currentObj)
    //清空计时器
    // clearInterval(timer.current);
    if (currentTab === 1) {
      setPayStatus({ ...payStatus, member: 0 })
      setPayResult({
        ...payResult,
        member: {
          goodsId: currentId,
        },
      })
    } else {
      setPayStatus({ ...payStatus, bag: 0 })
      setPayResult({
        ...payResult,
        bag: {
          goodsId: currentId,
        },
      })
    }
    setQrCodeLoading(true)

    getQrcode({ goodsId: currentId, type: 1,couponIds:currentObj?.couponId, useCoupon: currentObj?.useCoupon })
      .then((res: any) => {
        const { qrCodeUrl, paySerial, isCanPurchase = 0 } = res.data || {}
        //开始计时器
        clearInterval(timer.current)
        CreateTimer(paySerial)
        setQrCode(qrCodeUrl)
        setIsCanPurchase(isCanPurchase)
        setQrCodeLoading(false)
      })
      .catch((err: any) => {
        setQrCodeLoading(false)
      })
  }
  const itemClick = (id: any) => {
    setCurrentId(id)
  }
  const payWayClick = (way: any) => {
    setPayWay(way)
  }

  const renderPayCode = () => {
    if (currentTab === 2 && memberStatus !== 1) {
      return (
        <div className={styles.goToMember}>
          <div className={styles.tip}>
            加油包 <span>仅限会员购买</span>，非会员请先购买会员再购买加油包
          </div>
          <div
            className={styles.action}
            onClick={() => {
              setTab && setTab(1)
            }}
          >
            前往购买会员 {'>'}
          </div>
        </div>
      )
    } else if (isCanPurchase === 1) {
      return (
        <div className={styles.goToMember}>
          <div className={styles.tip}>
            你已开通 <span>连续订阅</span> 套餐，如果你想更换套餐，请先取消连续订阅。
          </div>
        </div>
      )
    } else {
      return (
        <div className={styles.paycontainer}>
          {/* <div className={styles.payment}>
        <div
          className={`${styles.payWay} ${payWay === 1 ? styles.activePay : ''}`}
          onClick={() => payWayClick(1)}
        >
          微信支付
        </div>
        <div
          className={`${styles.payWay} ${payWay === 2 ? styles.activePay : ''}`}
          onClick={() => payWayClick(2)}
          style={{ marginTop: 4 }}
        >
          支付宝支付
        </div>
      </div> */}
          <div className={styles.code}>
            <Spin
              className={styles.qrLoading}
              spinning={qrCodeLoading}
              indicator={<Loading3QuartersOutlined style={{ fontSize: 30 }} spin />}
            >
              <div className={styles.imgContainer}>
                {qrCode && <img src={qrCode} alt="" />}
                {payStatus[type[currentTab]] === 3 && (
                  <div
                    className={styles.codeMask}
                    onClick={() => {
                      getCode()
                    }}
                  >
                    <div className={`icon-rotate ${styles.update}`}></div>
                    刷新二维码
                  </div>
                )}
              </div>
            </Spin>
          </div>
          <div className={styles.payInfo}>
            <div className={styles.price} style={{ left: 0 }}>
              <div className={styles.priceSign}>￥</div>
              {currentObj?.sellAmount}
            </div>
            <div className={styles.paydes}>
              {(() => {
                  return (
                    <>{
                      currentObj?.supportPayments?.map((item:any)=>{
                        if(item?.payPlatformType===1){
                          return  <img key={item?.payPlatformType+'payWay'} src={wximg} alt="" />
                        }else if(item?.payPlatformType===2){
                          return <img key={item?.payPlatformType+'payWay'} src={zfbimg} alt="" />
                        }else{
                          return null
                        }
                      })
                    }
                    </>
                  )
              })()}
              请扫码完成支付
            </div>
            <div className={styles.xy}>
              开通服务即表示同意<span onClick={() => window.open(`/protocol?type=pay`)}>《WIME服务订购协议》</span>
            </div>
          </div>
        </div>
      )
    }
  }

  const calculateInCents=(yuan1:number, yuan2:number,type='minus')=> {
    const cents1 = Math.round(yuan1 * 100);
    const cents2 = Math.round(yuan2 * 100);
    return type==='minus'?(cents1 - cents2) / 100:(cents1 + cents2) / 100;
}

  
    const renderPayCodeNew = () => <div className={styles.payCodeBox}>
        <div className={styles.topContent}>
            <div className={styles.paySHowAmount}><span>￥</span>{currentObj.showAmount}</div>
            {
                currentObj.originalAmount && currentObj.originalAmount !== currentObj.showAmount && <div className={styles.payOriginalAmount}>￥{currentObj.originalAmount}</div>
            }
            {
                (currentObj.cheapAmount > 0||currentObj.couponAmount>0 ) && <div className={styles.payDiscountAmount}>已省<span>￥{calculateInCents(currentObj.cheapAmount||0,currentObj.couponAmount||0,'plus')}</span></div>
            }
            <div className={styles.codeBox} onClick={()=>{
              // setPrice(90)
              // // setTimeout(()=>{
              // //   setPrice(pre=>pre+5)
              // // },2000)
            }}>
                <Spin
                    className={styles.qrLoading}
                    spinning={qrCodeLoading}
                    indicator={<Loading3QuartersOutlined style={{ fontSize: 30 }} spin />}
                >
                    <div className={styles.imgContainer}>
                        {qrCode && <img src={qrCode} alt="" />}
                        {
                            payStatus[type[currentTab]] !== 3 &&
                            !(currentTab === 2 && memberStatus !== 1) &&
                            !(memberStatus === 1 && isCanPurchase === 1) &&
                            !qrCodeLoading &&
                            <div className={styles.scanner} />
                        }
                        {payStatus[type[currentTab]] === 3 && (
                            <div
                                className={styles.codeMask}
                                onClick={() => {
                                    getCode()
                                }}
                            >
                                <div className={`icon-rotate ${styles.update}`}></div>
                                刷新二维码
                            </div>
                        )}
                        {(currentTab === 2 && memberStatus !== 1 && userInfo?.oemFlag !== 1) && (
                            <div className={styles.codeMask}>
                                <div onClick={() => { setTab && setTab(1) }} className={styles.goMemberTab}>购买会员 <i className={`icon-ArrowRight-2 ${styles.icon}`} /></div>
                            </div>
                        )}
                        {memberStatus === 1 && isCanPurchase === 1 && (
                            <div className={styles.codeMask}>
                                <div onClick={() => { onCancel(); history.push({ pathname: `/personal-center?tabType=${TabType.我的订单}` }); }} className={styles.goPersonalCenter}>查看订单 <i className={`icon-ArrowRight-2 ${styles.icon}`} /></div>
                            </div>
                        )}
                    </div>
                </Spin>
            </div>
            <div className={styles.payMethods}>
                {
                    currentObj?.supportPayments?.map((item: any) => {
                        if (item?.payPlatformType === 1) {
                            return <img key={item?.payPlatformType + 'payWay'} src={wximg} alt="" />
                        } else if (item?.payPlatformType === 2) {
                            return <img key={item?.payPlatformType + 'payWay'} src={zfbimg} alt="" />
                        } else {
                            return null
                        }
                    })
                }
                请扫码完成支付
            </div>
        </div>

        <div className={styles.xy}>
            开通服务即表示同意<br />
          {
            isOemSaas ? <>
                <span onClick={() => window.open(`/protocol?type=waiservice`)}>《微盟软件服务协议》</span><br />
                <span onClick={() => window.open(`/protocol?type=waipay`)}>《在线支付协议》</span>
            </> : <span onClick={() => window.open(`/protocol?type=pay`)}>《WIME服务订购协议》</span>
          }
        </div>
    </div>
    
    const renderBottom = () => {
        if (memberStatus !== 1 && currentTab === 2) {
            return <div className={styles.notAllowBuyText}>
                加油包<span>仅限会员购买</span>， 非会员请先购买会员再购买加油包。
            </div>
        }
        if (isCanPurchase === 1) {
            return <div className={styles.notAllowBuyText}>
                您已开通<span>连续订阅</span>套餐，如果你想更换套餐，请先取消连续订阅。
            </div>
        }
        return <div className={`${styles.functionListBox} ${currentTab === 2 && styles.bagFunctionListBox}`} ref={scrollRef}>
          <img src={currentTab===1
            ?"https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/huiyuantaocan-quanyi@3x.png" 
            :"https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/jiayoubao-quanyi@3x.png"} alt="" />
            {/* <div className={styles.title}>{functionListMap[currentTab].title}</div>
            <div className={`${styles.functionList} ${currentTab === 2 && styles.bagFunctionList}`}>
                {
                    functionListMap[currentTab].list.map((functionItem: any) => <div className={styles.functionItem}>
                        <img src={functionItem.icon} className={styles.icon} />
                        <span className={styles.text}>{functionItem.text}</span>
                        {currentTab === 2 && <span className={styles.desc}>{functionItem.desc}</span>}
                    </div>)
                }
            </div> */}
        </div>
    }

  switch (payStatus[type[currentTab]]) {
    case 0:
    case 3:
      return (
        <div className={styles.content}>
            { showPromptTab === currentTab && <div className={styles.promptTxt}><span className={`icon-SignInfo ${styles.icon}`}></span>{ promptTxtMap?.[showPromptTab] }</div> }
          <div className={styles.goods}>
            {goodsList?.map((item: any) => {
              return (
                <div
                  key={'goods' + item.goodsId}
                  className={`${styles.item} ${item.goodsId === currentId ? styles.active : ''} ${showPromptTab !== -1 && showPromptTab === currentTab && styles.withPrompt}`}
                  onClick={() => itemClick(item.goodsId)}
                >
                  {item.tagText && <div className={styles.newTip}>{item.tagText}</div>}
                  {/* {(item.goodsId === 24 || item.goodsId === 30) && <div className={styles.newTip}>{item.amountContent}</div>} */}
                  <div className={styles.goodName}>{[24,30,36,37, 38].includes(item.goodsId)?`${goodsIdCardMap[item.goodsId]}天体验卡`:item.goodsName}</div>
                  <div className={styles.price}>
                    {/* <div className={styles.priceSign}>￥</div> */}
                    {/* {item.showAmount} */}
                    <PriceFlipper priceClassName={styles.priceContainer} tipClassName={styles.priceSign} key={item.goodsId} value={item.showAmount} height={item.goodsId === currentId?52:36} duration={0.5}/>
                    
                    {/* {item.goodsId === 24 && <span className={styles.tiyan}>体验3天</span>} */}
                    {item.isFirstMonth && <div className={styles.firstMonth}>首月</div>}
                  </div>
                    {
                        currentTab === 1 ? <>
                            {[24,30,36,37, 38].includes(item.goodsId) ? <span className={styles.amountContent}>连续包季</span> : <span className={classNames(styles.originalAmount)}>{`￥${item.originalAmount}`}</span>}
                            <span className={classNames(styles.bottomTips,{[styles.couponAmount]:item.couponAmount>0})}>{item.couponAmount>0?`已用券减${item.couponAmount}元`:item.amountContent}</span>
                        </> : currentTab !== 1 && <span className={classNames(styles.amountContent,{[styles.couponAmount]:item.couponAmount>0})}>{item.couponAmount>0?`已用券减${item.couponAmount}元`:item.amountContent}</span>
                    }
                  {/* {!(item.goodsId === 14 || item.goodsId === 24) && item.originalAmount && item.originalAmount !== item.showAmount && (
                    <div className={styles.originPrice}>原价￥{item.originalAmount}</div>
                  )} */}
                  {/* {item.goodsId === 14 && (
                    <div className={styles.originPrice} style={{ textDecoration: 'none' }}>
                      约4800张图
                    </div>
                  )} */}
                  {/* {item.goodsId === 24 && (
                    <div className={styles.originPrice} style={{ textDecoration: 'none' }}>
                      到期自动续89元/季
                    </div>
                  )} */}
                  {/* {!(item.goodsId === 14) && (
                    <div className={styles.bottom}>
                      <span className={styles.bottomText}>{item.amountContent}</span>
                    </div>
                  )}
                  {item.goodsId === 14 && (
                    <div className={styles.bottom}>
                      {cutdownShow ? (
                        <div className={styles.cutDown}>
                          <Countdown
                            title={null}
                            value={Number(deadLineTime)}
                            format="mm:ss:SSS"
                            onFinish={() => {
                              console.log('onFinishonFinishonFinish', new Date().getTime(), deadLineTime)
                              setCutdownShow(false)
                            }}
                          />
                          <span className={styles.bottomText}> 后结束</span>
                        </div>
                      ) : (
                        <span className={styles.bottomText}>{item.amountContent}</span>
                      )}
                    </div>
                  )} */}
                </div>
              )
            })}
          </div>

          <div className={styles.des}>
            <span dangerouslySetInnerHTML={{ __html: currentObj?.goodsDesc }}></span>
            {currentObj?.subscriptionType !== 0 && (
              <Popover
                placement="bottomRight"
                overlayClassName={styles.tipPopContainer}
                content={
                  <div className={styles.popTip}>
                    自动续费服务声明
                    <br />
                    1.到期当天为您自动续费
                    <br />
                    2.可随时取消自动续费服务，取消后不再自动续费
                    <br />
                    3.可在【个人中心-订单记录-取消自动续费】中查看取消自动续费方法
                  </div>
                }
              >
                <span className={`${styles.tipIcon} icon-SignQuestionFill`}></span>
              </Popover>
            )}
          </div>
            
          <div className={styles.payCode}>{renderPayCodeNew()}</div>
          {renderBottom()}
        </div>
      )
      break
    case 1:
      let curResultObj = {}
      if (currentTab === 1) {
        curResultObj = goodsList.filter((i: any) => i.goodsId === payResult['member'].goodsId)?.[0] || {}
      } else {
        curResultObj = goodsList.filter((i: any) => i.goodsId === payResult['bag'].goodsId)?.[0] || {}
      }
      return (
        <div className={styles.content}>
          <div className={`${styles.payResult} ${styles.successPart}`}>
            <div className={styles.ac}>
              <div className={`icon-StatusSuccess ${styles.icon}`} />
              <div className={styles.result}>支付成功</div>
            </div>
            {currentTab === 1 && (
              <div className={styles.des1}>
                恭喜{benefitType === 7 || benefitType === 99 ? '您已升级' : '你已成'}为 <span>{curResultObj?.goodsName || ''}</span>{' '}
                {(curResultObj?.subscriptionType !== 0 || curResultObj?.goodsId === 14) && '会员'}
                {(benefitType === 7 || benefitType === 99) && '，体验卡中剩余微力已累加到新会员权益中。'}
              </div>
            )}
            {currentTab === 1 && <div className={styles.des2}>会员有效期：{memberExpireTime}</div>}
            {currentTab === 2 && (
              <div className={styles.des}>
                恭喜你已成功购买 <span>{curResultObj?.goodsName || ''}</span> 加油包
              </div>
            )}
          </div>
          <CustomerService />
        </div>
      )
    case 2:
      return (
        <div className={styles.content}>
          <div className={`${styles.payResult} ${styles.failPart}`}>
            <div className={styles.ac}>
              <div className={`icon-StatusFailed ${styles.icon}`} />
              <div className={styles.result}>支付失败</div>
            </div>
            <div className={styles.desc}>请尝试重新进行支付</div>
          </div>
          <CustomerService />
        </div>
      )
    default:
      return <div></div>
  }
}